/**
* DevExpress Dashboard (_text-box-item-editor-view-model.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import * as ko from 'knockout';
import { getLocalizationById } from '../../data/localization/_default';
import { ConfirmDialogViewModel } from '../confirm-dialog/_confirm-dialog';
export class ValueAccessor {
}
export class RichEditExtensionViewModel {
    constructor() {
        this._isCloseConfirmed = false;
        this.richEditorOptions = ko.observable(null);
        this.close = () => {
            this.popup.hide();
        };
        this.saveAndClose = () => {
            var richEditorOptions = this.richEditorOptions();
            richEditorOptions && richEditorOptions.forceSave && richEditorOptions.forceSave();
            this.close();
        };
        this.onHidden = () => {
            this.richEditorOptions(null);
            this._isCloseConfirmed = false;
        };
        this.onHiding = (args) => {
            var richEditorOptions = this.richEditorOptions();
            var documentModified = richEditorOptions && richEditorOptions.documentModified && richEditorOptions.documentModified();
            if (documentModified && !this._isCloseConfirmed) {
                args.cancel = true;
                this.confirmDialogViewModel
                    .confirm(getLocalizationById('DashboardWebStringId.Dialog.ConfirmSaving'), getLocalizationById('DashboardWebStringId.SaveConfirmationDialogMessage') + '<br/>' + getLocalizationById('DashboardWebStringId.SaveChangesDialogMessage'), getLocalizationById('DashboardWebStringId.Dialog.Save'), getLocalizationById('DashboardWebStringId.Dialog.DoNotSave'))
                    .done(result => {
                    this._isCloseConfirmed = true;
                    if (result) {
                        this.saveAndClose();
                    }
                    else {
                        this.close();
                    }
                });
            }
        };
        this.onInitialized = (args) => {
            this.popup = args.component;
        };
        this.confirmDialogViewModel = new ConfirmDialogViewModel();
    }
    show(options, docVariables, dashboardItemWidth, callbacks) {
        if (!this.richEditorOptions()) {
            this.popup.show().then(() => {
                this.richEditorOptions({
                    initialDocument: options.getValue(),
                    docVariables: docVariables,
                    onSaving: (document) => {
                        options.setValue(document);
                    },
                    dashboardItemWidth: dashboardItemWidth,
                    ...callbacks,
                });
            });
        }
    }
}
